import { render } from "./BankInformation.vue?vue&type=template&id=0ebfe2e0&scoped=true"
import script from "./BankInformation.vue?vue&type=script&lang=js"
export * from "./BankInformation.vue?vue&type=script&lang=js"

import "./BankInformation.vue?vue&type=style&index=0&id=0ebfe2e0&lang=scss&scoped=true"

import exportComponent from "D:\\svn_gongzuo\\_____base\\GoPay\\v3_gopay\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ebfe2e0"]])

export default __exports__